/* eslint-disable react/prop-types */
import { useQuery } from "@apollo/client";
import { shape } from "prop-types";
import { useSelector } from "react-redux";

import { ErrorComponentWithContainer } from "web/Layout/Common/ErrorComponent";
import Loading from "web/Layout/Common/Loading";
import { getLanguageCode } from "web/Layout/Translations/LanguageWrapper";

import helpCenterCategory from "web/queries/default/helpCenterCategory.graphql";

import useLangFromParams from "web/hooks/useLangFromParams/useLangFromParams";

import newRelicErrorReport from "web/utils/system/essentials/newRelicErrorReport";

import { useAppContext } from "web/context/app";

import Desktop from "./Desktop";
import Mobile from "./Mobile";

const HCCategoryPage = ({ category }) => {
  const { isMobile } = useAppContext();
  const { help_center_prefix: prefix } = useSelector(
    (state) => state.app.storeConfig
  );

  const Comp = isMobile ? Mobile : Desktop;

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Comp {...category} prefix={prefix} />;
};
HCCategoryPage.propTypes = {
  category: shape({}).isRequired,
};

const HCCategoryContainer = ({ id }) => {
  const { languageFromParam } = useLangFromParams();

  const { error, loading, data } = useQuery(helpCenterCategory, {
    variables: {
      categoryId: [id],
      lang: languageFromParam || getLanguageCode(),
    },
    fetchPolicy: "cache-and-network",
  });

  switch (true) {
    case !!loading && (!data || !Object.keys(data).length): {
      return <Loading />;
    }
    case !!error: {
      newRelicErrorReport(
        error,
        "web-app/web/Pages/HelpCenterCategory/container.js - 47"
      );
      console.error(error);
      return <ErrorComponentWithContainer />;
    }
    default: {
      return data &&
        data.helpCenterCategory &&
        data.helpCenterCategory.category[0] ? (
        <HCCategoryPage category={data.helpCenterCategory.category[0]} />
      ) : null;
    }
  }
};

export default HCCategoryContainer;
